import { PaymentRequestChannelType } from '@api/index';

export const checkIsCallCenterPayment = (
  paymentRequestChannel: PaymentRequestChannelType
) => !(paymentRequestChannel === PaymentRequestChannelType['SHOP_AND_FLY_WEB']);
